/**
 * Create Task manifest — `create-tasks` action.
 *
 * Walks any source → contact. Opens create-tasks modal pre-loaded with the
 * resolved contact as the linked entity AND the source entity (so the task
 * is double-linked: deal task assigned to a contact at the deal's company).
 *
 * For deals: walks deal → company → contact (pick).
 */

import { MODAL_IDS } from "@west-tennessee-consulting/ui";

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "create-tasks",
  label: "Create task",
  primaryEntity: "contact",
  requires: {
    entity: "contact",
    requiredFields: [],
  },
  mode: "client-redirect",
  clientRun: (resolved, hooks) => {
    hooks.openModal(MODAL_IDS.tasks.create, {
      contactId: resolved.targetIds[0],
      contactIds: resolved.targetIds,
      sourceEntity: resolved.sourceEntity,
      sourceId: resolved.sourceId,
    });
  },
});
